import { openModal } from '@core/components/ModalStack';
import { AddEditTerritoryModalProps } from './AddEditTerritoryModal';

export async function openAddEditTerritoryModal(props: AddEditTerritoryModalProps) {
  const { AddEditTerritoryModal } = await import('./AddEditTerritoryModal');

  openModal(AddEditTerritoryModal, props);
}
